export const VEHICLE_TYPES = {
  C: 'Car',
  V: 'Van',
  M: 'Bike',
  B: 'Bicycle',
};

export const VEHICLE_SEATS_QTY = [2, 3, 4, 5, 6, 7, 8, 9];
